import { render, staticRenderFns } from "./NetShopTakeOutUsage.vue?vue&type=template&id=77ef7b7e&scoped=true"
import script from "./NetShopTakeOutUsage.vue?vue&type=script&lang=js"
export * from "./NetShopTakeOutUsage.vue?vue&type=script&lang=js"
import style0 from "./NetShopTakeOutUsage.vue?vue&type=style&index=0&id=77ef7b7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef7b7e",
  null
  
)

export default component.exports